module.exports = __webpack_public_path__ + "img/winerackdog40.970d3f23.jpg";